import "./BuySellToggleQuoteComponent.scss";
import template from "./BuySellToggleQuoteComponent.html";
import {IComponentOptions, IRootElementService} from "angular";
import {QuoteViewModel} from "../../models/QuoteViewModel";
import {ComponentCallback} from "../../../types/AngularJS";
import {OrderSide} from "../../../orders/models/OrderRecord";
import {EquityOrderWizardStore} from "../../../portfolio/templates/ticket/place-equity-order-wizard/store/EquityOrderWizardStore";

export const BuySellToggleQuote = "tfBuySellToggleQuote";

export function buySellToggleQuote(): IComponentOptions {
    return {
        template,
        bindings: {
            store: "<",
            side: "<",
            hidePrice: "<",
            model: "<quote",
            onBidClicked: "&",
            onAskClicked: "&"
        },
        controllerAs: "ctrl",
        controller: BuySellToggleQuoteComponentController
    };
}

export class BuySellToggleQuoteComponentController {
    /** @input */
    public readonly model: QuoteViewModel;
    public readonly side: OrderSide;
    public readonly store: EquityOrderWizardStore;

    /** @output */
    public readonly onBidClicked: ComponentCallback;

    /** @output */
    public readonly onAskClicked: ComponentCallback;

    public readonly hasBidClick: boolean;
    public readonly hasAskClick: boolean;

    /** @ngInject */
    public constructor($element: IRootElementService) {
        this.hasBidClick = $element.attr("on-bid-clicked") != null;
        this.hasAskClick = $element.attr("on-ask-clicked") != null;
    }
}
